import React, { Component } from "react";
import { connect } from "react-redux";
import { CustomDrawer } from "../../BookingPortal/components/Shared/Drawer";
import Recaptcha from "react-recaptcha";
import debounce from "lodash/debounce";
import { CustomTextField } from "./FormFields/TextField";
import { verificationSelector } from "../selectors";
import {
  addToWaitingList,
  submitBooking,
  verifyCode,
  requestVerificationCode,
  toggleVerifyDrawer
} from "../actions";
import { goToPage } from "../../BookingPortal/actions";
import { RECAPTCHA_KEY } from "../../../api/config";

class VerificationDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      errorText: "",
      isValid: false,
      recaptchaToken: ""
    };
    this.recaptchaInstance = null;
    this.debouncedValidate = debounce(this.validate, 300);
  }

  validate = async () => {
    let errorText = "";
    let valid = false;
    if (this.state.input.length !== 6) {
      errorText = "Code is not valid!";
    } else {
      valid = await this.props.verifyCode(this.state.input);
      if (!valid) errorText = "Code is not valid!";
    }

    this.setState({ errorText, isValid: valid });
  };

  verifyRecaptcha = response => {
    if (response) {
      this.setState({ isValid: true, recaptchaToken: response });
    }
  };

  handleBlur = () => {
    if (this.state.input.length < 6 && !this.state.errorText) {
      this.setState({ errorText: "Code is not valid" });
    }
  };

  handleInputChange = e => {
    const self = this;
    const { value } = e.target;
    this.setState({ input: value }, () => {
      if (value.length > 6 || value.length === 0) {
        self.setState({ errorText: "Code is not valid" });
      } else if (value.length === 6) {
        self.debouncedValidate();
      } else {
        self.setState({ errorText: "" });
      }
    });
  };

  handleCodeResend = () => {
    this.setState({ input: "", errorText: "" });
    this.props.requestVerificationCode();
  };

  handleRecapthaCheck = (e, checked) => {
    if (this.recaptchaInstance) {
      this.recaptchaInstance.reset();
    }
    this.setState({
      isValid: false,
      recaptchaToken: ""
    });
  };

  handleBookingSubmit = async () => {
    try {
      await this.props.submitBooking(
        this.state.input,
        this.props.useRecaptcha,
        this.state.recaptchaToken
      );
      this.props.goToPage("confirm");
    } catch (e) {
      this.props.toggleVerifyDrawer(false);
    }
  };

  handleDawerRequestChange = open => {
    this.props.toggleVerifyDrawer(open);
  };

  renderVerificationMethod = () => {
    if (this.props.useRecaptcha) {
      return (
        <Recaptcha
          ref={e => (this.recaptchaInstance = e)}
          sitekey={RECAPTCHA_KEY}
          render="explicit"
          verifyCallback={this.verifyRecaptcha}
        />
      );
    }

    return (
      <CustomTextField
        id="code_input"
        floatingLabelText="Verification Code"
        onBlur={this.handleBlur}
        onChange={this.handleInputChange}
        errorText={this.state.errorText}
        style={{ width: "100%" }}
        inputStyle={{ padding: "0 0.5em" }}
        isValid={this.state.isValid}
        underlineFocusStyle={{ borderColor: "#ed135d" }}
      />
    );
  };

  render() {
    return (
      <CustomDrawer
        docked={true}
        open={this.props.isOpen}
        onRequestChange={this.handleDawerRequestChange}
      >
        <span className="drawer-title-small">
          {this.props.useRecaptcha
            ? "Complete verification below, then click Confirm"
            : "A confirmation code was sent to your mobile device"}
        </span>
        <div className="verification-sms-container">
          {this.renderVerificationMethod()}
          {/* <Checkbox
            label="Use recaptcha to verify"
            onCheck={this.handleRecapthaCheck}
            style={{ marginTop: "5px" }}
          /> */}
          <div className="verification-sms-btn-container">
            <button
              className="btn btn-transparent-black verification-sms-left-btn"
              onClick={() => this.props.toggleVerifyDrawer(false)}
            >
              Cancel
            </button>
            <div className="verification-sms-right-btn-panel">
              {!this.props.useRecaptcha ? (
                <button
                  className="btn btn-transparent-pink"
                  onClick={this.handleCodeResend}
                >
                  Resend
                </button>
              ) : null}
              <button
                className="btn btn-transparent-pink"
                disabled={!this.state.isValid}
                onClick={this.handleBookingSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </CustomDrawer>
    );
  }
}

export default connect(verificationSelector, {
  submitBooking,
  addToWaitingList,
  verifyCode,
  toggleVerifyDrawer,
  requestVerificationCode,
  goToPage
})(VerificationDrawer);



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/VerificationDrawer.js